import {IAppRoute} from "../../application/config/IAppRoute";

import {routeTestsPage} from "./routeTestsPage";

export const routesTestPages: IAppRoute<any>[] = [
  routeTestsPage,
];
